/*eslint-disable*/
export default page => {
  const lazyModules = page.querySelectorAll('.js-lazy-load-module')
  const setOnLoad = node => {
    let trackerArr = []
    let nodeMedia = node.querySelectorAll('.flickity-lazyload, .js-lazy-load-media, .js-lazy-load-media-mobile')
    nodeMedia.forEach((media, i) => {
      // console.log(media)
      if (media.nodeName === 'IMG') { // If an image source, set up image on load
        $(media).one('load', () => {
          if (!media.src.includes(`${$(media).data('image-src')}`)) {
            $(media).attr('src', $(media).data('image-src')) // failsafe in case src doesn't get reset
          }
        })
        $(media).on('load', () => {
          $(media).removeAttr('data-loading')
          trackerArr.push(i)
          if (trackerArr.length === nodeMedia.length) $(node).addClass('loaded')
        })
      } else if (media.nodeName === 'SOURCE') { // If a video source, set up video on load
        $(media).closest('video').on('loadstart', () => {
          $(media).removeAttr('data-loading')
          trackerArr.push(i)
          if (trackerArr.length === nodeMedia.length) $(node).addClass('loaded')
        })
      } else { // otherwise, we are either setting a background-image or there are no images
        trackerArr.push(i)
        if (trackerArr.length === nodeMedia.length) $(media).removeAttr('data-loading')
      }
    })
  }
  const loadImages = node => {
    if (node && !node.classList.contains('loaded')) {
      let nodeMedia = node.querySelectorAll('.flickity-lazyload, .js-lazy-load-media, .js-lazy-load-media-mobile')
      if ($(node).offset().top <= $(window).scrollTop() + $(window).height() + 500) { // only set image source if the element is within view, higher up, or coming up (within 500px out of view)
        if (nodeMedia.length) {
          nodeMedia.forEach((media, i) => { // Set src attribute for each image, using data-image-sr
            if (!$(node).hasClass('loaded') && !$(media).data('loading')) { // if the node isn't already loaded or loading
              if (media.nodeName === 'IMG') $(media).attr('src', $(media).data('image-src'))
              else if (media.nodeName === 'SOURCE') {
                media.src = $(media).data('video-src')
                $(media).closest('video').attr('poster', $(media).closest('video').data('poster'))
                $(media).closest('video').load().closest('js-lazy-load-module').addClass('loaded')
              } else { // if we are setting a background image, not an img element
                $(media).css('background-image', `url(${$(media).data('image-src')})`)
                nodeMedia.length - 1 === i && $(node).addClass('loaded')
              }
              $(media).data('loading', true) // sets loading attribute to true, so we don't go through all this work again when the image is already loading
            }
          })
        }
      }
    }
  }

  // Trigger on load, on scroll, on resize
  $(document).ready(() => {
    lazyModules.length && lazyModules.forEach(lazyModule => {
      setOnLoad(lazyModule)
      !lazyModule.classList.contains('loaded') && loadImages(lazyModule)
    }) // set onload logic for each lazy loaded module for when image is ready to go
  })
  $(window).bind('scroll.lazy resize.lazy', () => lazyModules.length && lazyModules.forEach(lazyModule => {
    if ($(lazyModule).offset().top <= $(window).scrollTop() + $(window).height() - 150) !lazyModule.classList.contains('top') && lazyModule.classList.add('top') && console.log('visible') // set top to 0 when node is in view, even if image isn't loaded yet
    !lazyModule.classList.contains('loaded') && loadImages(lazyModule)
  }))
}



// WEBPACK FOOTER //
// ./src/scripts/components/lazy-loader.js